import firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/storage';
import 'firebase/messaging';
//import 'firebase/analytics'
import 'firebase/auth';
import 'firebase/database';
import 'firebase/remote-config';

const firebaseConfig = {
  apiKey: "AIzaSyAbbcMheVwueXq95KNV3UgvoJSp3cbKUh8",
  authDomain: "yumrestaurants-a46ba.firebaseapp.com",
  databaseURL: "https://yumrestaurants-a46ba.firebaseio.com",
  projectId: "yumrestaurants-a46ba",
  storageBucket: "yumrestaurants-a46ba.appspot.com",
  messagingSenderId: "839597240787",
  appId: "1:839597240787:web:6b88b5c1f291569da43f26",
  measurementId: "G-FVQFJ9W64Q"
};

firebase.initializeApp(firebaseConfig);
//firebase.analytics();

// const fstore = firebase.firestore();
// const storageFB = firebase.storage();
const fdatabase = firebase.database();
const fauth = firebase.auth();
const fremoteConfig = firebase.remoteConfig();
fremoteConfig.settings = {
  minimumFetchIntervalMillis: 1000 * 60 * 60
};
fremoteConfig.defaultConfig = {
  authdomain: 'yumrestaurantes.com'
}

const fmessaging = firebase.messaging();

export { fdatabase, fauth, fmessaging, fremoteConfig };
